import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2'
import { CommonService } from 'src/app/services/common.service';

@Component({
    selector: 'app-appointement-details',
    templateUrl: './appointement-details.component.html',
    styleUrls: ['./appointement-details.component.css'],
    standalone: false
})
export class AppointementDetailsComponent implements OnInit {
  token: any;
  id: any;
  appointment: any;

  note: any[] = [];
  offeres: any[] = [];
  package: any = null;

  notes = {
    diagnosis: null,
    description: null
  }

  edit_notes = {
    diagnosis: null,
    description: null
  }

  note_id: any;

  Swal = 'sweetalert2';

  cancel_reason: any = 'NONE';

  reasons: any[] = ['NONE',
    'Cancelled by Patient',
    'Cancelled by Doctor',
    'DNA',
    'Departed'
  ];

  invoice = {
    private_discount: 0,
    amount_due: 0,
    quantity: 1,
    total_amount: 0,
    payment_package: 'FULL',
    payment_type: 'CASH'
  }

  constructor(public utility: UtilitiesService, public api: ApiService, public datepipe: DatePipe, private modalService: NgbModal, private router: Router, public common: CommonService) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
    this.id = localStorage.getItem('id');
  }

  open(content: any) {
    this.modalService.open(content);
  }

  edit(content: any, note: any) {
    this.edit_notes = note;
    this.note_id = note.id;

    this.modalService.open(content);
  }

  ngOnInit(): void {
    let item = localStorage.getItem('appointment');
    if (item) {
      this.appointment = JSON.parse(item);
      if (this.appointment) {
        this.getNotes();
        this.getDoctorDetails(this.appointment.appointment.doctor_id);
        this.invoice.amount_due = this.appointment.appointment.amount_due;
        this.invoice.total_amount = +this.appointment.appointment.amount_due * +this.invoice.quantity;
      }
    }
  }

  async OnSumbit() {
    const body = {
      title: this.appointment.appointment.service,
      description: this.notes.description,
      diagnosis: this.notes.diagnosis,
      details: [],
      patient_id: this.appointment.patient.id,
      appointment_id: this.appointment.appointment.id,
      doctor_id: this.appointment.appointment.doctor_id,
      user_id: this.id
    }

    const sub = this.api.post("notes/", body, this.token).subscribe(
      async data => {
        Swal.fire({
          title: 'Success!',
          text: 'Created Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    sub.add(() => { this.getNotes(); this.modalService.dismissAll(); });
  }

  getNotes() {
    const sub = this.api.get('notes/open/appointment/' + this.appointment.appointment.id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.note = objects.notes;
      },
      async error => { }
    );

    sub.add(() => { this.getPatientPackges(this.appointment.patient.id); });
  }

  getPatientPackges(id: any) {
    const sub = this.api.get('package_patients/patient/' + id + '/service/' + this.appointment.appointment.service_id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        if (objects) this.package = objects[0];
      },
      async error => { }
    );

    sub.add(() => { this.getPirvateOffer(); });
  }

  async getPirvateOffer() {
    const sub = this.api.get('offers/private', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.offeres = objects;
      },
      async error => { }
    );

    sub.add(() => { this.utility.loading = false; });
  }

  getDoctorDetails(id: any) {
    const sub = this.api.get('employees/role/doctor/' + id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.appointment.doctor = objects[0];
      },
      async error => { }
    );

    sub.add(() => { });
  }

  async OnUpdate(id: any) {
    const body = {
      description: this.edit_notes.description,
      diagnosis: this.edit_notes.diagnosis,
    }

    const sub = this.api.update("notes/" + id, body, this.token).subscribe(
      async data => {
        Swal.fire({
          title: 'Success!',
          text: 'Created Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    sub.add(() => { this.getNotes(); this.modalService.dismissAll(); });
  }

  OnDelete(id: any) {
    Swal.fire({
      title: 'Do you want to delete this Note?',
      showCancelButton: true,
      icon: 'question',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        const sub = this.api.delete('notes/' + id, this.token).subscribe(
          async data => {
            Swal.fire({
              title: 'Success!',
              text: 'Deleted Successfuly!',
              icon: 'success',
              confirmButtonText: 'Cool'
            })
          },
          async error => {
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong!',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        );

        sub.add(() => { this.getNotes(); });
      }
    });
  }

  onDeleteAppointment(item: any) {
    Swal.fire({
      title: 'Do you want to delete this appointment?',
      showCancelButton: true,
      icon: 'question',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        this.api.delete('appointments/' + item.id, this.token).subscribe(
          async data => {
            this.api.delete('schedules/' + item.slot_id, this.token).subscribe(
              async data => {
                this.router.navigate(['appointments']);
              },
              async error => { return error; }
            );
          },
          async error => {
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong!',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        );
      }
    })
  }

  approve(id: any) {
    Swal.fire({
      title: 'Appintment paied and Patient came?',
      showCancelButton: true,
      icon: 'success',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        const sub = this.api.update(`appointments/update_status/${id}/COMPLETED/NONE`, {}, this.token).subscribe(
          async data => {
            this.appointment.appointment.status = 'COMPLETED';
            Swal.fire({
              title: 'Success!',
              text: 'Updated Successfuly!',
              icon: 'success',
              confirmButtonText: 'Cool'
            })
          },
          async error => {
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong!',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        );

        sub.add(() => { this.modalService.dismissAll(); });
      }
    })
  }

  reject(id: any) {
    Swal.fire({
      title: 'This appointment will be cancelled',
      showCancelButton: true,
      icon: 'warning',
      confirmButtonText: 'Ok',
    }).then((result) => {
      if (result.isConfirmed) {
        let status = 'PENDING';
        let reason = 'NONE';

        if (this.cancel_reason === 'NONE') {
          status = 'CANCELLED';
          reason = 'NONE';
        }
        if (this.cancel_reason === 'Cancelled by Patient') {
          status = 'CANCELLED';
          reason = 'CANCLED_BY_PATIENT';
        }
        if (this.cancel_reason === 'Cancelled by Doctor') {
          status = 'CANCELLED';
          reason = 'CANCLED_BY_DOCTOR';
        }
        if (this.cancel_reason === 'DNA') {
          status = 'MISSED';
          reason = 'DNA';
        }
        if (this.cancel_reason === 'Departed') {
          status = 'MISSED';
          reason = 'DEPARTED';
        }

        const sub = this.api.update(`appointments/update_status/${id}/${status}/${reason}`, {}, this.token).subscribe(
          async data => {
            this.appointment.appointment.status = status;
            this.appointment.appointment.reason_not_happened = reason;
            Swal.fire({
              title: 'Success!',
              text: 'Updated Successfuly!',
              icon: 'success',
              confirmButtonText: 'Cool'
            })
          },
          async error => {
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong!',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        );

        sub.add(() => { this.modalService.dismissAll(); });
      }
    })
  }

  is_hidden(appointment: any) {
    // if (this.utility.isAdmin())
    //   return false;

    if (appointment.is_happened == true || appointment.is_paied == true)
      return true;

    return false
  }

  is_hidden_appointment(appointment: any) {
    if (appointment.payment_id)
      return true;
    return false
  }

  calculate() {
    this.invoice.total_amount = +this.invoice.amount_due * +this.invoice.quantity;
  }

  async create(appointment: any) {
    let details: any = {}
    details.service = appointment.appointment.service;
    details.period = appointment.appointment.period;
    details.date = appointment.appointment.date;
    details.doctor_name = appointment.doctor.name;
    details.patient_name = appointment.patient.first_name + ' ' + appointment.patient.last_name;
    details.patient_address = appointment.patient.address;
    details.patient_number = appointment.patient.patient_number;
    details.patient_phone = appointment.patient.phone;
    details.visiting_reason = appointment.patient.visiting_reason;
    details.amount_due = this.invoice.amount_due;
    details.quantity = this.invoice.quantity;
    details.total_amount = this.invoice.total_amount;

    // check payment type ... 
    if (this.invoice.payment_package === 'INSTALLMENT') {
      // package details ...
      // what about if patient already paied for all the sessions? 
      // installment only for packages
      // full for both installements and others
      if (this.package.service_id === appointment.appointment.service_id) {
        let number_sessions = 5;
        let paied_amount = 0;

        if (this.package.paied_amount == 0) {
          const { value: sessions } = await Swal.fire({
            title: 'Note: At leaset 5 Sessions should be payed in advance..!',
            input: 'number',
            inputValue: 5,
            inputLabel: 'Number of Sessions'
          })

          if (+sessions > +this.package.no_sessions)
            number_sessions = this.package.no_sessions
          else number_sessions = sessions;


          this.package.no_sessions_paid = +number_sessions;
          paied_amount = +this.package.session_price * +number_sessions;

          details.quantity = number_sessions;
          details.total_amount = +this.package.session_price * +number_sessions;
        }
        else {
          // check paid amount for number of sessions 
          if (+this.package.no_sessions_took >= +this.package.no_sessions_paid) {
            const { value: sessions } = await Swal.fire({
              title: 'Please pay for the next sessions first!',
              input: 'number',
              inputValue: 5,
              inputLabel: 'Number of Sessions',
              allowOutsideClick: false
            })

            number_sessions = sessions;

            this.package.no_sessions_paid = +number_sessions;
            paied_amount = +this.package.session_price * +number_sessions;

            details.quantity = number_sessions;
            details.total_amount = +this.package.session_price * +number_sessions;
          }
        }
        this.package.no_sessions_took = +this.package.no_sessions_took + 1;
        this.package.no_sessions_left = +this.package.no_sessions_left - 1;

        this.package.paied_amount = paied_amount;
        this.invoice.total_amount = paied_amount;

        details.package = this.package;

        this.updatePackageSubscription(appointment, details);
      }
      else {
        Swal.fire({
          title: 'Note!',
          text: 'This Patient has no packages on this Service!!',
          icon: 'warning',
          confirmButtonText: 'Ok'
        });
      }
    } else {
      // full for both installements and others
      if (this.package) {
        details.quantity = this.package.no_sessions;
        details.total_amount = +this.package.session_price * +this.package.no_sessions;

        this.package.no_sessions_paid = +this.package.no_sessions;
        this.package.paied_amount = +this.package.session_price * +this.package.no_sessions;

        details.package = this.package;

        this.updatePackageSubscription(appointment, details);
      }
      else this.create_invoice(appointment, details);
    }
  }

  updatePackageSubscription(appointment: any, details: any) {
    this.api.update("package_patients/" + details.package.id, details.package, this.token).subscribe(
      async data => { this.create_invoice(appointment, details) },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );
  }

  create_invoice(appointment: any, details: any) {
    details.offer = this.common.offer;
    details.speical_discount = this.offeres.find(i => i.id === this.invoice.private_discount);

    const body = {
      payment_type: this.invoice.payment_type,
      payment_package: this.invoice.payment_package,
      note: `Payment for service ${appointment.appointment.service}, quantity= ${this.invoice.quantity}, amount= ${appointment.appointment.amount_due}`,
      vat: null,
      amount: this.invoice.total_amount,
      client_id: this.appointment.patient.id,
      appointment_id: this.appointment.appointment.id,
      details: details
    }

    const sub = this.api.post("payments/", body, this.token).subscribe(
      async data => {
        // success message ...
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'success',
          title: 'Payment Created Successfully'
        })

        let objects: any = {}
        objects = data;

        let id = objects.id;
        /* update appointment ... */
        let body = {
          payment_id: id,
          total_amount_due: this.invoice.total_amount,
          discount: 0,
          amount_due: this.invoice.amount_due
        }
        this.update_appointment(appointment.appointment.id, body);
        /* end update  */

        await this.delay(2200);
        this.router.navigate([]).then(result => { window.open('invoice_print?id=' + id, '_blank'); });
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    sub.add(() => {
      this.modalService.dismissAll();
    });
  }

  update_appointment(id: any, body: any) {
    this.api.update("appointments/payment/" + id, body, this.token).subscribe(
      async data => { },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  print_invoice(client_id: any, appointment_id: any) {
    this.router.navigate([]).then(result => { window.open('invoice_print?appointment_id=' + appointment_id + '&client_id=' + client_id, '_blank'); });
  }

  disablePackage(_package: any) {
    Swal.fire({
      title: 'Are you sure you want to disable the subscription?',
      showCancelButton: true,
      icon: 'question',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        const sub = this.api.update("package_patients/disable/" + _package.id, {}, this.token).subscribe(
          async data => {
            Swal.fire({
              title: 'Success!',
              text: 'Updated Successfuly!',
              icon: 'success',
              confirmButtonText: 'Cool'
            })
          },
          async error => {
            Swal.fire({
              title: 'Error!',
              text: 'Something went wrong!',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
          }
        );
        sub.add(() => { this.getPatientPackges(this.appointment.patient.id); });
      }
    });
  }
}
